/* External dependencies */
import * as XLSX from 'xlsx';

export async function convertExcelFileToArray(file: File): Promise<unknown[]> {
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });

  const sheetName = workbook.SheetNames[0];
  const sheet = workbook.Sheets[sheetName];
  const array = XLSX.utils.sheet_to_json(sheet) || [];

  return array;
}
